export default "__VITE_ASSET__6WERBB25__"